import React from 'react';
import { MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { values } from 'lodash';

import Select from 'components/@common/Inputs/Select';
import { WdtCharacterOrder } from 'types/schema-generated-types';

interface CharacterOrderPickerProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CharacterOrderPicker: React.FC<CharacterOrderPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation('Reports');
  const options = [WdtCharacterOrder.hwt, WdtCharacterOrder.natural];
  return (
    <Select
      placeholder={t('Select the Order')}
      value={value}
      size="small"
      name="characterOrder"
      inputProps={{
        'aria-label': t('Select the Order')
      }}
      onChange={onChange}
    >
      {values(options).map(option => (
        <MenuItem key={`${option}-character-order-option`} value={option}>
          {t(option, { ns: 'WdtCharacterOrder' })}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CharacterOrderPicker;
